import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import ExpenseAndIncomeReportPage from './ExpenseAndIncomeReport';

const LoanPaymentReport = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Ingresos y Gastos' pageTitle='Reportes' />
                <ExpenseAndIncomeReportPage />
            </div>
        </React.Fragment>
    )
}

export default LoanPaymentReport;